import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import CustomerDetails from "./CustomerDetails";
import LimitOverride from "./LimitOverride";
import UploadDocument from "./UploadDocument";
import Attributes from "./Attributes";
import CommonButton from "../Utils/CommonButton";
import { PAGE_TITLES } from "../Common/constants";
import { AttributeNameOptions } from "./constants/constantValues";
import { customerDialCodeErrorThrow } from "./constants/DocumentTableFunctions";
import { NonSearchableAttributes } from "./NonSearchableAttributes";
import { Identifiers } from "./Identifiers";
import { useState } from "react";
import { validateForm } from "./constants/TelcoSubmitFunctions";
import { CustomerCategory } from "./Category";
import { useSelector } from "react-redux";

export const CommonCustomerDetails = ({
  setFieldError,
  isAIPath,
  searchableFormErrorsValues,
  setSearchableFormErrorValues,
  nonSearchableFormErrorsValues,
  setNonSearchableFormErrorValues,
  searchableAttributes,
  nonSearchableAttributes,
  setNonSearchableValues,
  searchableValues,
  nonSearchableValues,
  setSearchableValues,
  identifiers,
  Attributes,
  title,
  customerPermission,
  values,
  touched,
  bdomOptions,
  errors,
  dialCode,
  setDialCode,
  setFieldValue,
  onfocus,
  setOnFocus,
  setFieldTouched,
  initialValues,
  handleBlur,
  handleChange,
  options,
  optionCity,
  optionState,
  setSelectedCountry,
  setSelectedState,
  setSelectedCity,
  cityData,
  setCities,
  isEdit,
  documentPermission,
  fetchDocumentData,
  open,
  setIsOpen,
  file,
  setFile,
  fileName,
  setFileName,
  setState,
  setTouched,
  roleName,
  navigate,
  isProfile,
  setIsProfile,
  profilePicture,
  setProfilePicture,
  inputFileRef,
  dispatch,
  setLoading,
  customerId,
  setUpdate,
  setFileSelected,
  documentName,
  dynamicGroups,
  setDynamicGroups,
  listAttributesForBinding
}) => {
  const [setAllTouched, setSetAllTouched] = useState(() => () => {});
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
    
  );

  // const categoryOptions = operatorConfiguration?.configurations
  //   ?.find((config) => config.name === "CustomerCategory")
  //   ?.value?.find((item) => item.key === "Categories")
  //   ?.value?.map((category) => ({ label: category, value: category }));
    const categoryOptions = (
    operatorConfiguration?.configurations?.CustomerCategory?.value?.Tags?.value ??
    operatorConfiguration?.configurations?.CustomerCategory?.value?.Categories?.value ??
    []
  )?.map(category => ({ label: category, value: category })) ?? [];
  // const isEIPEnabled =
  //   operatorConfiguration?.configurations
  //     ?.find((config) => config.name === "EIP")
  //     ?.value?.find((item) => item.key === "Enabled")?.value?.[0] === "True";
  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value ?? false;

  const customerListTitle = isEIPEnabled
    ? isEdit
      ? PAGE_TITLES.EDIT_CUSTOMER_EIP
      : PAGE_TITLES.ADD_CUSTOMER_EIP
    : isEdit
    ? PAGE_TITLES.EDIT_CUSTOMER
    : PAGE_TITLES.ADD_CUSTOMER;

  const moduleTitle = isEIPEnabled
    ? PAGE_TITLES.CUSTOMER_LIST_EIP
    : PAGE_TITLES.CUSTOMER_LIST;

  return (
    <Container fluid>
      {(roleName !== "telcoAdmin" || (roleName === "telcoAdmin" && isEdit)) && (
        <>
          <BreadCrumb
            title={customerListTitle}
            pageTitle={customerListTitle}
            moduleTitle={moduleTitle}
          />
          <h5 className="rv-page-title p-0 ps-1 pb-3">{customerListTitle}</h5>
        </>
      )}
      <Row>
        <Col lg={12}>
          <div className="border rounded-1 p-3">
            <h4 className="card-title mb-0 flex-grow-1 rv-form-title">
              Primary Contact
            </h4>

            {/* <CardBody className="card-body"> */}
            <div className="live-preview">
              <CustomerDetails
                customerPermission={customerPermission}
                values={values}
                touched={touched}
                bdomOptions={bdomOptions}
                errors={errors}
                dialCode={dialCode}
                setDialCode={setDialCode}
                setFieldValue={setFieldValue}
                onfocus={onfocus}
                setOnFocus={setOnFocus}
                setFieldTouched={setFieldTouched}
                initialValues={initialValues}
                handleChange={handleChange}
                handleBlur={handleBlur}
                options={options}
                optionState={optionState}
                optionCity={optionCity}
                setSelectedCountry={setSelectedCountry}
                setSelectedState={setSelectedState}
                setSelectedCity={setSelectedCity}
                cityData={cityData}
                setCities={setCities}
                isEdit={isEdit}
                isProfile={isProfile}
                setIsProfile={setIsProfile}
                profilePicture={profilePicture}
                setProfilePicture={setProfilePicture}
                inputFileRef={inputFileRef}
                dispatch={dispatch}
                setLoading={setLoading}
                customerId={customerId}
                setUpdate={setUpdate}
                setFileSelected={setFileSelected}
                documentName={documentName}
              />
            </div>
            {/* </CardBody> */}
          </div>
        </Col>
      </Row>
      <div className="border rounded-1 p-3 mt-3">
        <CustomerCategory
          setFieldError={setFieldError}
          values={values}
          errors={errors}
          touched={touched}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          handleBlur={handleBlur}
          categoryOptions={categoryOptions}
        />
        {!isEdit ? (
          <Row className="pt-4">
            <Col lg={12} className="pe-0">
              <h4 className="card-title flex-grow-1 rv-form-title">
                Limit Overrride
              </h4>
              <div className="live-preview">
                <LimitOverride
                  isEdit={isEdit}
                  values={values}
                  touched={touched}
                  bdomOptions={bdomOptions}
                  errors={errors}
                  dialCode={dialCode}
                  setDialCode={setDialCode}
                  setFieldValue={setFieldValue}
                  onfocus={onfocus}
                  setOnFocus={setOnFocus}
                  handleBlur={handleBlur}
                />
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
      {documentPermission && (
        <Row>
          <Col lg={12}>
            <UploadDocument
              fetchDocumentData={fetchDocumentData}
              isEdit={isEdit}
              open={open}
              setIsOpen={setIsOpen}
              file={file}
              setFile={setFile}
              fileName={fileName}
              setFileName={setFileName}
              setState={setState}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              values={values}
              errors={errors}
              handleChange={handleChange}
              handleBlur={handleBlur}
              touched={touched}
            />
          </Col>
        </Row>
      )}
      {(identifiers?.length > 0 || Attributes?.length > 0) && (
        <div className="border rounded-1 p-3 mt-3">
          <Identifiers
            searchableFormErrorsValues={searchableFormErrorsValues}
            searchableValues={searchableValues}
            setSearchableValues={setSearchableValues}
            setSetAllTouched={setSetAllTouched}
            identifiers={identifiers}
            roleName={roleName}
            setFieldValue={setFieldValue}
            isEdit={isEdit}
            handleBlur={handleBlur}
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
          />
          <NonSearchableAttributes
            isEdit={isEdit}
            nonSearchableFormErrorsValues={nonSearchableFormErrorsValues}
            nonSearchableValues={nonSearchableValues}
            setNonSearchableValues={setNonSearchableValues}
            Attributes={Attributes}
            dynamicGroups={dynamicGroups}
            setDynamicGroups={setDynamicGroups}
            existingAttributes={listAttributesForBinding}
            showGenerateButton={false}
          />
        </div>
      )}
      <Row className="my-4 mb-5">
        <div className="d-flex justify-content-between gap-2 flex-wrap">
          <div className="me-auto">
            <CommonButton
              outline={true}
              className={
                "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              }
              color={"main-color"}
              type={"reset"}
              buttonAction={() => navigate("/customer")}
              buttonText={"Back"}
              icon={
                <i
                  className="ri-play-mini-fill label-icon align-middle fs-16 me-2"
                  style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}
                ></i>
              }
              btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
            />
          </div>
          <div className="d-flex gap-2 ">
            <CommonButton
              outline={true}
              className={
                "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              }
              color={"main-color"}
              type={"reset"}
              buttonAction={() => navigate("/customer")}
              buttonText={"Cancel"}
              icon={
                <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
              }
              btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
            />
            <CommonButton
              color={"main-color"}
              className={
                "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              }
              icon={
                (roleName !== "telcoAdmin" &&
                  roleName !== "telcoOperationUser" &&
                  roleName !== "telcoBusinessUser") ||
                ((roleName === "telcoAdmin" ||
                  roleName === "telcoOperationUser" ||
                  roleName === "telcoBusinessUser") &&
                  isEdit) ||
                isAIPath ? (
                  <i className="ri-save-line label-icon align-middle fs-16 me-2"></i>
                ) : (
                  <i className="ri-play-mini-fill label-icon align-middle fs-16 me-2"></i>
                )
              }
              btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              type={"submit"}
              buttonAction={() => {
                customerDialCodeErrorThrow(onfocus, dialCode, setOnFocus);
                const searchableFormErrors = validateForm(
                  searchableAttributes,
                  searchableValues
                );
                setSearchableFormErrorValues(searchableFormErrors);
                const nonSearchableFormErrors = validateForm(
                  nonSearchableAttributes,
                  nonSearchableValues
                );
                setNonSearchableFormErrorValues(nonSearchableFormErrors);
              }}
              buttonText={
                (roleName !== "telcoAdmin" &&
                  roleName !== "telcoOperationUser" &&
                  roleName !== "telcoBusinessUser") ||
                ((roleName === "telcoAdmin" ||
                  roleName === "telcoOperationUser" ||
                  roleName === "telcoBusinessUser") &&
                  isEdit) ||
                isAIPath
                  ? "Save"
                  : "Next"
              }
            />
          </div>
        </div>
      </Row>
    </Container>
  );
};
